export const SET_RESTAURANT_LIST = "SET_RESTAURANT_LIST" 
export const SET_RESTAURANT_ID = "SET_RESTAURANT_ID" 
export const SET_USER_CART = "SET_USER_CART" 
export const CLEAR_USER_CART = "CLEAR_USER_CART" 
export const SET_ORDER_TYPE = "SET_ORDER_TYPE" 
export const SET_SELECTED_RESTAURANT = "SET_SELECTED_RESTAURANT" 
export const SET_LOADING_FALSE = "SET_LOADING_FALSE" 
export const SET_LOADING_TRUE = "SET_LOADING_TRUE" 